<template>
  <FileUploadField
    name="proofOfResidency"
    iconType="NameUserCard"
    iconColor="#00D6BF"
    :errors="form.proofOfResidencyErrors"
    :label="$t('FileUploadField.label.proofOfResidency')"
    :placeholder="$t('FileUploadField.placeholder.selectOrDrag')"
    @updateFile="updateFile"
  />
</template>

<script setup>
import { ref, watch, computed } from "vue";
import FileUploadField from "@/components/ui/inputs/FileUploadField.vue";
import { useIdentityStore } from "@/stores/forms/identityFormStore";
import useFormValidation from "@/composables/validations/useFormValidation";

const store = useIdentityStore();
const { validateFileInput } = useFormValidation();
const form = ref({
  proofOfResidency: null,
  proofOfResidencyErrors: null,
});
const $emit = defineEmits(["enableSubmitButton"]);
const updateFile = (file) => {
  const fileValidationErrors = validateFileInput("proofOfResidency", file);

  form.value.proofOfResidency = file;
  store.updateValue("proofOfResidency", form.value.proofOfResidency);
  store.updateState("proofOfResidency", fileValidationErrors);
  form.value.proofOfResidencyErrors = fileValidationErrors;
};

const formHasErrors = computed(() => {
  const anyErrors = form.value.proofOfResidencyErrors !== "";
  const anyFieldsEmpty = form.value.proofOfResidency.length === 0;

  return anyErrors || anyFieldsEmpty;
});

watch(
  () => formHasErrors.value,
  () => {
    $emit("enableSubmitButton", formHasErrors.value);
  },
  { deep: true }
);
</script>
<style lang="scss" scoped></style>
